// src/components/latest-results/ENTTestGroup.jsx
import ENTTestRow from "./ENTTestRow";

export default function ENTTestGroup({
  groupName,
  detail,
  images,
  onAddImage,
  onRemoveImage,
  onRemoveAll,
  maxImages,
  showHeader = true,
}) {
  return (
    <div className="space-y-4">
      {showHeader && (
        <div className="flex items-center justify-between flex-wrap gap-3">
          <button className="bg-[#D7D4F8] text-[#845BB3] px-4 py-2 rounded-md font-semibold text-xl">
            {groupName}
          </button>
          <span className="text-sm font-semibold text-[#845BB3]">
            ENT Imaging
          </span>
        </div>
      )}

      <ENTTestRow
        detail={detail}
        images={images}
        onAddImage={onAddImage}
        onRemoveImage={onRemoveImage}
        onRemoveAll={onRemoveAll}
        maxImages={maxImages}
      />
    </div>
  );
}
